module.exports = __webpack_public_path__ + "img/icon-arrow.51804510.svg";